/**
 * 决定性规则，执行完该文件的规则应该直接进入AFTER算法，计算出投注金额和格式化请求对象
 * 权重区间20000 - 10000 步长100
 */

import combinatorics from '../../../helpers/combinatorics'
import { SPECIAL_SINGLE } from '../singleMethods'


export default function Decision(R){
	return [
		// 复式
		{
			priority: 20000,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'multi') );
		    },
		    consequence: function(R) {
		    	let num = 1;
		    	_.forEach(this.formatCodes, function(item){
		    		num *= item.length
		    	})
		    	this.num = num;
		        R.next();
		    }
		},
		/**
		 * 通用单式
		 */
		{
			priority: 19900,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'single') );
		    },
		    consequence: function(R) {
		    	// 单式去重
					let codes = this.formatCodes;
					const singleRule = _.filter(SPECIAL_SINGLE, item => _.includes(item.matcherNames, this.mathcherName))[0] || SPECIAL_SINGLE.default;
					let realCode = singleRule.filter(codes);
					let uniqueCode = _.uniq(realCode);
		    	if (realCode.length != uniqueCode.length) {
		    		this.message.push('以下号码重复，已进行自动去重');
		    		this.message.push(_.chain(realCode).groupBy().filter((item) => item.length > 1).map((item) => item[0]).map((item) => _.isArray(item) ? _.join(item, ' ') : item).join(',').value());
		    	}
		    	this.formatCodes = uniqueCode;
		    	// 单式正则过滤
		    	let errorCodes = [];
		    	let currentCodes = [];

		    	// 构建正则表达式
		    	let regex = _.replace(singleRule.regex, '$', this.attached.number);
		    	regex = new RegExp('^' + regex +'$')
		    	_.forEach(this.formatCodes, function(item){
		    		if(!regex.test(item)){
		    			if (!_.isUndefined(item)) {
		    				errorCodes.push(item)
		    			}
		    			return true;
		    		}
		    		if (!singleRule.hasZero) {
		    			currentCodes.push(item);
		    			return true;
		    		}
				    if(_.sortBy(_.split(item,' ')).length==_.uniq(_.sortBy(_.split(item,' '))).length){
				    	currentCodes.push(item);
				    	return true
				    }
		    		if (!_.isUndefined(item) ) {
				    	errorCodes.push(item)
				    }

		    	})
		    	if (errorCodes.length > 0 && _.uniq(errorCodes)!='') {
		    		this.message.push('以下号码错误，已进行自动过滤');
		    		this.message.push( _.join(errorCodes, ',') );
		    	}
		    	this.formatCodes = currentCodes;

		    	// 组选去重
		    	if (this.attached.flag === 'group') {
		    		// 带0的单式组选，使用空格分割
		    		this.sortSplit = singleRule.sortSplit || '';
		    		const sortCodes =  _.chain(this.formatCodes).map((item) => _.sortBy(_.split(item, this.sortSplit))).uniqBy((it)=>JSON.stringify(it)).value();
		    		let repeatCodes = [];
		    		_.forEach(sortCodes, function(item){
		    			// 三个号都相同
		    			if (_.uniq(item).length === 1) {
		    				repeatCodes.push(item);
		    			}
		    		})
		    		const finalCodes = _.chain(sortCodes).difference(repeatCodes).map((item) => _.join(item, this.sortSplit)).value();
		    		const removedCodes = _.filter(this.formatCodes, (item) => !_.includes(finalCodes, item));
		    		if (removedCodes.length > 0) {
		    			this.message.push('已经过滤以下号码');
		    			this.message.push( _.join(removedCodes, ',') );
		    		}
		    		this.formatCodes = _.difference(sortCodes, repeatCodes);
		    	}
		    	this.num = this.formatCodes.length;
		        R.next();
		    }
		},
		// 组合玩法
		{
			priority: 19800,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'combination') );
		    },
		    consequence: function(R) {
		    	let num = this.formatCodes.length;
		    	_.forEach(this.formatCodes, function(item){
		    		num *= item.length
		    	})
		    	this.num = num;
		        R.next();
		    }
		},
		// 组选
		{
			priority: 19700,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'multi-combination') );
		    },
		    consequence: function(R) {
		    	// 至少有一组值没有达到最小选择量
		    	let noFinish = false;
		    	_.forEach(this.currentMethod.selectarea.layout, function(item, index){
		    		if(this.formatCodes[item.place].length < item.minchosen){
		    			noFinish = true;	
		    		}
		    	}.bind(this))

		    	// 如果有一组值没有达到最小选择数
		    	if (noFinish) {
		    		this.num = 0;
		    	}else{
		    		let num = 0;
		    		// 得到单行的组合项		    	
			    	let eachCombination = [];
			    	_.forEach(this.formatCodes, function(item, index){
			    		eachCombination[index] = combinatorics.combination(item, _.find(this.currentMethod.selectarea.layout, {place: index}).minchosen).toArray();
			    	}.bind(this))

			    	// 所有行的组合项进行合并
			    	let allCombination = combinatorics.cartesianProduct( ...eachCombination ).toArray();
		    	
			    	// 将每一组得多行值进行合并
			    	_.forEach(allCombination, function(item, index){
			    		allCombination[index] = _.concat( ...item );
			    	})
			    	// 去重，比较
			    	_.forEach(allCombination, function(item, index){
			    		if (item.length === _.uniq(item).length) {
			    			num ++;
			    		}
			    	})

			    	this.num = num;
		    	}
				
				R.next();
		   		
		    }
			
		},
		/**
		 * 和值
		 * 从SCOPE中取N位数进行组合，组合的值求和取尾数比较
		 * @param  {[Array]}  attached.scope [取值区间，默认0-9]
		 * @param  {[Number]} attached.number [取多少个数]
		 * @param  {[String]} attached.flag [直选还是组选 direct/group]
		 * @param  {[Boolen]} attached.isTail [是否为尾数相等] <<<<<<< 由于奖金组关系，尾数和值不走该算法
		 */
		{
			priority: 19600,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'sum-plus') );
		    },
		    consequence: function(R) {
		    	this.attached.scope = this.attached.scope || [0,1,2,3,4,5,6,7,8,9];
		    	// 构造待组合二维数组
		    	let pendingArr = _.times(this.attached.number, _.constant(this.attached.scope) ); 
				//获取全部组合类型
				let allCombination = combinatorics.cartesianProduct(...pendingArr).toArray();
				let num = 0;
				_.forEach(this.formatCodes[0], function(code){
					let eachCombination = [];
					_.forEach(allCombination, function(codeSet){
						if ( !this.attached.isTail && _.sum(codeSet) === Number(code) ) {
							eachCombination.push( _.sortBy(codeSet) )
						}
						// 尾数相等
						if ( this.attached.isTail && (_.sum(codeSet) % 10)  === Number(code) ) {
							eachCombination.push( _.sortBy(codeSet) )
						}
					}.bind(this))
					if (this.attached.flag == 'group') {
						// 组选和值
						eachCombination = _.filter(eachCombination, function(item){return _.uniq(item).length != 1})
						num += _.uniqBy(eachCombination, function(item){return JSON.stringify(item)}).length;
					}else{
						num += eachCombination.length;
					}
				}.bind(this))
				// 排序
			    this.formatCodes[0] = _.chain(this.formatCodes[0]).map((item) => parseInt(item)).sortBy().map((item) => String(item)).value();
				this.num = num;
				R.next();
		    }
		},
		/**
		 * 任选直选玩法
		 * 
		 */
		{
			priority: 19500,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'any-chosen') );
		    },
		    consequence: function(R) {
		    	let num = 0;
		    	let eachNumbers = [];
		    	// 判断多少组数据
		    	const groupNum = _.times(this.formatCodes.length);
		    	// 交叉组合任选位置
		    	const positionGroup = combinatorics.combination(groupNum, this.attached.number).toArray();
		    	// 通过一个循环组合所有可能情况
		    	_.forEach(positionGroup, function(position){
		    		let currentCodeSet = [];
		    		let isFinish = true;
		    		_.forEach(position, function(index){
		    			if(this.formatCodes[index].length === 0){
		    				isFinish = false;
		    				return false;
		    			}
		    			currentCodeSet.push(this.formatCodes[index]);
		    		}.bind(this))
		    		if (isFinish) {
		    			const _number = combinatorics.cartesianProduct(...currentCodeSet).toArray().length;
		    			eachNumbers.push(_number);
		    			num += _number;
		    		}
		    	}.bind(this))
		    	// 最小的一种组合注数（提供给单挑标识使用）
		    	this.minNumber = _.min(eachNumbers);
		    	this.num = num;
				R.next();
		    }
		},
		/**
		 * 倍数算法，一号N注
		 * 一个号乘以N
		 * @param  {[Number]} attached.number [N倍，默认1]
		 * 一号一注，或者包胆，一号54注等
		 */
		{
			priority: 19400,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'times-chosen') );
		    },
		    consequence: function(R) {
		    	// 如果已经算出来过值，那么进行直接进行倍数算法
		    	if (!_.isUndefined(this.num)) {
		    		this.num *= this.attached.number;
		    	}else{
		    		let codesSum = [];
		    		const times = this.attached.number || 1;
			    	_.forEach(this.formatCodes, function(item){
		    			if(item != ''){
		    				codesSum.push(item.length * times)
			    		}
			    	})
			    	this.num = _.sum(codesSum);
		    	}
				R.next();
		    }
		},
		/**
		*通选算法
		**/
		{
			priority: 19400,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'general-election') );
		    },
		    consequence: function(R) {
		    	// 如果已经算出来过值，那么进行直接进行倍数算法
		    	if(this.formatCodes[0][0]=="通选"){
		    		this.num = 1
		    	}else{
		    		this.num = 0
		    	}
				R.next();
		    }
		},
		/**
		 * 任选位数算法
		 * 当任选玩法不是直选时，经过前面的算法得出一个注数
		 * 通过该算法求得选择位置的组合长度
		 * 然后用位置组合长度与前面算法得到的注数相乘，得到一个新的注数
		 * @param  {[Number]} attached.number [N码]
		 */
		{
			priority: 15000,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'position-chosen') );
		    },
		    consequence: function(R) {
		    	let num = 0;
		    	// 如果选的位数小于最小选择量
		    	const selectedPosition = _.filter(this.bet.poschoose, (item) => item );
		    	const minNumber = this.attached.posnum || this.attached.number
		    	if (minNumber > selectedPosition.length ) {
		    		this.num = 0;
		    	}else{
			    	// 排列方式
			    	const combination = combinatorics.combination(selectedPosition, minNumber).toArray().length
		    		this.num *= combination;
		    	}
				R.next();
		    }
		},
		/**
		 * 跨度算法
		 * @param  {[Number]} attached.number [N码]
		 * @param  {[Number]} attached.scope  [号码范围，默认0-9]
		 */
		{
			priority: 19300,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'span-chosen') );
		    },
		    consequence: function(R) {
		    	let num = 0;
		    	this.attached.scope = this.attached.scope || [0,1,2,3,4,5,6,7,8,9];
		    	let pendingArr = _.times(this.attached.number, _.constant(this.attached.scope) ); 
		    	// 从scope中选N，所有组合方式
		    	let allCombination = combinatorics.cartesianProduct(...pendingArr).toArray();
		    	// 排序
		    	allCombination = _.chain(allCombination).map((item) => _.sortBy(item)).value();
				// 遍历，判断相等
				_.forEach(allCombination, function(item, index){
					_.forEach(this.formatCodes, function(eachCodes){
						_.forEach(eachCodes, function(code){
							if ((item[item.length - 1] - item[0]) === Number(code)) {
					            num ++;
							}
						})
					}.bind(this))
				}.bind(this))
				this.num = num;
				R.next();
		    }
		},
		/**
		 * 通用组合算法，从M中选N组合
		 * @param  {[Number]} attached.number [N]
		 */
		{
			priority: 19950,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'combination-chosen') );
		    },
		    consequence: function(R) {
		    	let num = 0;
		    	// 最小选择值
		    	if (this.formatCodes[0].length < this.attached.number) {
		    		this.num = 0;
		    	}else{
		    		this.num = combinatorics.combination(_.times(this.formatCodes[0].length, _.constant(['']) ), this.attached.number).toArray().length;
		    	}
				R.next();
		    }
		},
		/**
		 * 猜名次算法
		 */
		{
			priority: 19200,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'ranking-chosen'));
		    },
		    consequence: function(R) {
		    	// 是否每一个位置都已经选择了值
		    	let noFinish = false;
		    	_.forEach(this.formatCodes, function(item){
		    		if(item.length === 0){
		    			noFinish = true;	
		    		}
		    	})
		    	if (noFinish) {
		    		this.num = 0;
		    	}else{
		    		// 所有组合方式
		    		let allCombination = combinatorics.cartesianProduct(...this.formatCodes).toArray();
		    		allCombination = _.filter(allCombination, (item) => item.length === _.uniqBy(item).length);
		    		this.num = allCombination.length;
		    	}
				R.next();
		    }
		},
		/**
		三不同号 和值选号
		*/
		{
			priority: 19600,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'sum-plus-dif') );
		    },
		    consequence: function(R) {
		    	this.attached.scope = this.attached.scope || [1,2,3,4,5,6];
		    	// 构造待组合二维数组
		    	let pendingArr = _.times(this.attached.number, _.constant(this.attached.scope) ); 
				//获取全部组合类型
				let allCombination = combinatorics.cartesianProduct(...pendingArr).toArray();
				let num = 0;
				_.forEach(this.formatCodes[0], function(code){
					let eachCombination = [];
					_.forEach(allCombination, function(codeSet){
						if ( !this.attached.isTail && _.sum(codeSet) === Number(code) ) {
							eachCombination.push( _.sortBy(codeSet) )
						}
						// 尾数相等
						if ( this.attached.isTail && (_.sum(codeSet) % 10)  === Number(code) ) {
							eachCombination.push( _.sortBy(codeSet) )
						}
					}.bind(this))
					if (this.attached.flag == 'group') {
						// 组选和值
						eachCombination = _.filter(eachCombination, function(item){
							return _.uniq(item).length != 1
						})
						num += _.uniqBy(eachCombination, function(item){return JSON.stringify(item)}).length;
						eachCombination = _.uniqBy(eachCombination, function(item){return JSON.stringify(item)})
						let n = 0  //找出每组有重复号码的数组的长度  
						_.forEach(eachCombination,function(code,index){
							if(code[0]==code[1]||code[0]==code[2]||code[1] == code[2]){
								n++
							}
						})
						num = num - n
					}else{
						num += eachCombination.length;
					}
				}.bind(this))
				
				this.num = num;
				R.next();
		    }
		},
		//对决 竞速
		{
			priority: 19200,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'ranking-pk'));
		    },
		    consequence: function(R) {
		    	// 是否每一个位置都已经选择了值
		    	let n = 0
		    	_.forEach(this.formatCodes, function(item){
		    		if(item.length==2){
		    			n++
		    		}
		    	})
		    	this.num = n
				R.next();
		    }
		},
		//三不同胆拖
		{
			priority: 18050,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'dantuo-dif-3') );
		    },
		    consequence: function(R) {
		    	if(this.formatCodes[1].length<4 && this.formatCodes[0].length == 0){
		    		this.num = 0
		    	}else if(this.formatCodes[1].length == 3 && this.formatCodes[0].length >= 1){
		    		this.num = 3
		    	}else if(this.formatCodes[1].length == 4 && this.formatCodes[0].length == 0){
		    		this.num = 4
		    	}else if(this.formatCodes[1].length == 4 && this.formatCodes[0].length == 1){
		    		this.num = 6
		    	}else if(this.formatCodes[1].length == 4 && this.formatCodes[0].length == 2){
		    		this.num = 4
		    	}else if(this.formatCodes[1].length == 5){
		    		this.num = 10
		    	}else if(this.formatCodes[1].length == 6 && this.formatCodes[0].length == 0){
		    		this.num = 20
		    	}
				R.next(); 
		    }
		},
		//二不同胆拖
		{
			priority: 18050,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'dantuo-dif-2') );
		    },
		    consequence: function(R) {
		    	if(this.formatCodes[0].length == 0){
		    		this.num = 0
		    	}else if(this.formatCodes[0].length == 1){
		    		this.num = this.formatCodes[1].length
		    	}
				R.next();
		    }
		}

	]
}